import React from 'react';
import { Select, SelectProps } from '@arco-design/web-react';
import { useSelect } from '../api';

export function SelectProject({ value, onChange, placeholder = '全部', ...rest }: SelectProps) {
  const { data, isLoading } = useSelect({
    params: {
      pageIndex: 1,
      pageSize: 1000,
    },
  });
  const _options = data
    ? data.data.items.map((v) => ({
        label: v.name,
        value: v.id,
      }))
    : [];
  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      options={_options}
      allowClear
      loading={isLoading}
      {...rest}
    />
  );
}
